import apiClient from './apiClient';

export async function fetchUsers() {
  const { data } = await apiClient.get('/identity/users');
  return data;
}

export async function fetchUserAlerts() {
  const { data } = await apiClient.get('/identity/alerts');
  return data;
}

export async function fetchPasswordPolicy() {
  const { data } = await apiClient.get('/identity/password-policy');
  return data;
}

export async function setUserStatus(id, status) {
  const { data } = await apiClient.patch(`/identity/users/${id}`, { status });
  return data;
}

export async function createUser(payload) {
  const { data } = await apiClient.post('/identity/users', payload);
  return data;
}
